<div class="common-modal__container">
  <!-- Cabecera -->
  <div class="common-modal__header">
    <span class="common-modal__text-header"
      [afTranslate]="'documentation-list.manage-confident'">_Gestionar confidencial</span>
  </div>
  <!-- Contenedor -->
  <div class="common-modal__content">
    <p class="common-modal__content-header-info"
      [afTranslate]="'manage-confidential-modal.info-header'">_La etiqueta de Confidencial marca aquellos contenidos con acceso restringido. Por defecto, solo el Responsable puede ver el elemento clasificado como confidencial, pero tiene la posibilidad de autorizar el acceso a otros usuarios.</p>
    <div class="common-modal__form-container">
     @if (manageConfidentialModal.showDeleteConfidential) {
      <field-type-switch [field]="{label: 'manage-confidential-modal.delete-confident'|afTranslate}"
        [small]="true"
        [preSelectItem]="manageConfidentialModal.check"
        (itemSelected)="manageConfidentialModal.check = $event.newValue">
      </field-type-switch>
     }
     @if (!manageConfidentialModal.check) {
      <field-type-text-simple
        [field]="manageConfidentialModal.responsibleConfidential"
        [preSelectItem]="manageConfidentialModal.confidentContacts?.preSelectedResponsible?.fullName">
      </field-type-text-simple>
      <field-type-contacts [field]="manageConfidentialModal.confidentContacts"
        [valueId]="manageConfidentialModal.valueIdContacts"
        (sendContacts)="receiveContacts($event)"
        (contactsClosed)="contactsClosed()">
      </field-type-contacts>
     }
    </div>
  </div>
  <!-- Footer botonera -->
   @if (manageConfidentialModal.showText || manageConfidentialModal.check) {
    <div class="common-modal__footer">
      <button class="common-button__text-border"
        (click)="handleDismiss()">
        <span class="common-button__text-title"
          [afTranslate]="'common.cancel'">_Cancelar</span>
      </button>
      <button class="common-button__text"
        (click)="handleAccept()">
        <span class="common-button__text-title"
          [afTranslate]="'common.save'">Guardar</span>
      </button>
    </div>
  }
</div>
